import styled from "@emotion/styled";

export const StyledFormicError = styled("p")(() => ({
  color: "red",
  padding: 0,
  margin: 0,
}));
